import * as React from 'react';

import { ContactsSegmentsResponse } from '../../../sic-lib/api/segments/types/ContactsSegmentsResponse';
import { ListItem } from '../../../sic-lib/types/Lists';
import { useAppSelector } from '../../../store/hooks';
import HeaderFilters from '../HeaderFilters/HeaderFilters';
import HeaderMassActions from '../HeaderMassActions/HeaderMassActions';

interface Props {
    appliedList: ListItem | ContactsSegmentsResponse;
}

export default function Header({ appliedList }: Props) {
    const selectAll = useAppSelector(state => {
        return state.conversationGrid?.selectAll || false;
    });

    const selected = useAppSelector(state => {
        return state.conversationGrid?.selected || [];
    });

    return (
        <React.Fragment>
            {(selectAll || selected.length > 0) && (
                <HeaderMassActions
                    selectAll={selectAll}
                    selected={selected}
                    listId={
                        appliedList.hasOwnProperty('listId')
                            ? (appliedList as ListItem).listId
                            : (appliedList as ContactsSegmentsResponse).segmentId
                    }
                />
            )}
            {!selectAll && selected.length < 1 && <HeaderFilters list={appliedList} />}
        </React.Fragment>
    );
}
